import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const apps = [
  { 
    name: 'Calendar', 
    path: '/calendar', 
    image: `${process.env.REACT_APP_CDN_URL}/icons/calendar.png`,
    description: 'Schedule and manage your appointments',
    color: 'from-soft-pink to-mint-green',
    useImage: true
  },
  {
    name: 'Connect',
    path: '/connect',
    image: `${process.env.REACT_APP_CDN_URL}/icons/connections.png`,
    description: 'Connect with your family and friends',
    color: 'from-soft-pink to-mint-green',
    useImage: true
  },
  {
    name: 'Meal Planner',
    path: '/meal-planner',
    image: `${process.env.REACT_APP_CDN_URL}/icons/meal-planner.png`,
    description: 'Plan your meals with AI-powered recommendations',
    color: 'from-soft-pink to-mint-green',
    useImage: true
  },
];

const AppCard = ({ app, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="group relative h-full"
    >
      <Link to={app.path} className="h-full block">
        <motion.div
          whileHover={{ 
            scale: 1.03,
            boxShadow: "0 15px 30px -10px rgba(0, 0, 0, 0.3)"
          }}
          whileTap={{ scale: 0.97 }}
          className="relative h-full bg-gradient-to-br from-pri-dark/90 to-sec-dark/95 rounded-xl overflow-hidden border border-white/5 shadow-lg transition-all duration-300"
        >
          {/* Top gradient highlight */}
          <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-soft-pink/40 to-transparent"></div>
          
          <div className="p-5 flex items-center">
            {/* Icon */}
            <div className="relative flex-shrink-0 mr-4">
              <div className="absolute inset-0 rounded-full blur-md bg-soft-pink/20 scale-90"></div>
              {app.useImage && (
                <motion.img 
                  src={app.image} 
                  alt={app.name} 
                  className="relative z-10 w-16 h-16 object-contain"
                  whileHover={{ rotate: [0, -5, 5, -5, 0] }}
                  transition={{ duration: 0.5 }}
                />
              )}
            </div>
            
            {/* Content */}
            <div className="flex-1">
              <h3 className="text-lg font-bold text-soft-pink mb-1 group-hover:text-pri-yellow transition-colors duration-300">
                {app.name}
              </h3>
              <p className="text-pri-white/70 text-sm group-hover:text-pri-white/90 transition-colors duration-300 line-clamp-2">
                {app.description}
              </p>
            </div>
            
            {/* Arrow indicator */}
            <div className="ml-2 text-soft-pink/50 group-hover:text-pri-yellow group-hover:translate-x-1 transition-all duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
          
          {/* Interactive hover effect */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-soft-pink/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </motion.div>
      </Link>
    </motion.div>
  );
};

const Applist = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto"
    >
      {apps.map((app, index) => (
        <AppCard key={app.name} app={app} index={index} />
      ))}
    </motion.div>
  );
};

export default Applist;
